<script>
  import i18n_translations from "../../javascript/locales.json"
  import { I18n } from "i18n-js"

  let { RailsApp, page_title, logo = true } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  let computed_title = $derived.by(() => {
    let title = page_title
    if (!title) {
      title = i18n.t(`${RailsApp.Request.controller}.${RailsApp.Request.action}.title`, { defaultValue: '' })
    }
    if (logo) {
      title = title ? `${title} - ${i18n.t('logo')}` : i18n.t('logo')
    }
    return title
  })
</script>

<svelte:head>
  <title>{computed_title}</title>
</svelte:head>